<template>
  <div class="relevance-manage">
    <el-card>
      <el-form :inline="true" :model="filter" size="small" label-width="110px">
        <el-form-item label="销售姓名：">
          <el-input v-model="filter.name" maxlength="20" placeholder="请输入销售姓名" />
        </el-form-item>
        <el-form-item label="销售手机号：">
          <el-input v-model="filter.mobile" maxlength="11" placeholder="请输入销售手机号" />
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top:10px">
      <el-table v-loading="loading" :data="list" border style="width: 100%" size='small'>
        <el-table-column prop="name" label="销售姓名" align="center" min-width="180px" />
        <el-table-column prop="mobile" label="企微手机号" align="center" min-width="180px" />
        <el-table-column prop="alias" label="别名" align="center" min-width="180px" />
        <el-table-column align="center" label="企微账号状态" min-width="120px">
          <template v-slot="{ row }">
            <span v-if="row.status === 1">已激活</span>
            <span v-else-if="row.status === 2">已禁用</span>
            <span v-else-if="row.status === 4">未激活</span>
            <span v-else-if="row.status === 5">退出企业</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="deptName" label="所在部门" align="center" min-width="180px" />
        <el-table-column label="关联活码数" align="center" min-width="120px">
          <template v-slot="{ row, $index }">
            <span v-if="/^[0-9]*$/.test(row.codeNum)">{{ row.codeNum }}</span>
            <a v-else @click="handleViewNum(row, $index)">查看</a>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="200px">
          <template v-slot="{ row }">
            <el-button type="text" size="small" @click="toView(row)">查看活码关联</el-button>
            <el-button type="text" size="small" @click="toAdd(row)">新增活码关联</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px"
        :page-sizes="[10, 20, 50, 100]"
        :current-page='filter.page'
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </el-card>
    <!-- 查看关联活码 -->
    <el-dialog
      :title="dialogTitle"
      width="960px"
      :visible.sync="dialogAccVisible"
      :close-on-click-modal="false"
      :before-close="handleCloseAcc"
    >
      <div v-loading="submitLoading" element-loading-text="数据同步中...">
        <el-form :model="accFilter" class="filer" size="small" label-width="120px" inline>
          <el-form-item label="渠道活码名称：">
            <el-input v-model.trim="accFilter.names" maxlength="20" placeholder="请输入渠道活码名称" />
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              v-model="dateList"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="timerange"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="" @click="handleFilter">搜索</el-button>
            <el-button size="" @click="handleResetFilter">重置</el-button>
          </el-form-item>
        </el-form>
        <template v-if="opearteType === 'add'">
          <div class="tags">
            <div style="margin-bottom:10px">已选择{{ accSelection.length }}个活码：</div>
            <div v-for="(tag, index) in accSelection" :key="tag.id">
              <el-tag style="margin:0 10px 10px 0;" size="mini" @close="handleDelSelection(tag)" v-if="index < 18" closable>
                {{tag.name}}
              </el-tag>
            </div>
            <div v-if="accSelection.length > 18">······</div>
          </div>
          <div class="operate-line">
            <el-button :disabled="!accSelection.length" size="small" @click="handleAdd">添加活码</el-button>
            <el-button size="small" type="primary" @click="handleAddAll">全部添加</el-button>
          </div>
        </template>
        <div v-else-if="opearteType === 'detail'" class="operate-line">
          <el-button :disabled="!accSelection.length" size="small" @click="handleDelete">删除活码</el-button>
          <el-button size="small" type="primary" @click="handleDeleteAll">全部删除</el-button>
        </div>
        <el-table
          ref='multipleTable'
          v-loading="accLoading"
          :data="accList"
          border size="small"
          @select="handleSelect"
          @select-all="handleSelectionAll"
        >
          <el-table-column type="selection" align="center" width="55" />
          <el-table-column align="center" label="渠道活码名称" prop="name" />
          <el-table-column align="center" label="状态">
            <template v-slot="{ row }">
              <span v-if="row.status === 1">正常</span>
              <span v-else-if="row.status === 2">禁用</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" prop="insertDate" />
          <el-table-column label="操作" align="center" fixed="right" min-width="80px">
            <template v-slot="{ row }">
              <el-button v-if="opearteType === 'detail'" type="text" size="small" @click="toDelete(row)">删除</el-button>
              <el-button v-else-if="opearteType === 'add'" type="text" size="small" @click="toChoose(row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="accFilter.page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="accFilter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="accTotal"
          @size-change="handleSizeChangeAcc"
          @current-change="handleCurrentChangeAcc"
        />
      </div>
      <span slot="footer" class="dialog-footer" />
    </el-dialog>
  </div>
</template>

<script>
import { getAccList, getQwLiveCodeList, batchDel, batchDelAll, batchAdd, batchAddAll, getRelevenceCodeNum } from '@/api/admin/saleQrcode.js'
import { unique } from '@/utils/handle'

export default {
  name: 'RelevanceManage',

  data () {
    return {
      loading: false,
      filter: {
        name: '',
        mobile: '',
        page: 1,
        limit: 10,
      },
      list: [],
      total: 0,
      opearteType: '',
      currentAcc: '',
      dialogAccVisible: false,
      accFilter: {
        qwUserId: '',
        names: '',
        insertStartDate: '',
        insertEndDate: '',
        flag: '',
        page: 1,
        limit: 10,
      },
      accTotal: 0,
      accLoading: false,
      accList: [],
      accSelection: [],
      submitLoading: false
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.accFilter.insertStartDate, this.accFilter.insertEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.accFilter.insertStartDate = v[0] + ' 00:00:00' || ''
          this.accFilter.insertEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.accFilter.insertStartDate = ''
          this.accFilter.insertEndDate = ''
        }
      }
    },
    dialogTitle () {
      switch (this.opearteType) {
        case 'detail':
          return `查看活码关联 - ${this.currentAcc}`
        case 'add':
          return `新增活码关联 - ${this.currentAcc}`
      }
      return ''
    }
  },
  created () {
    this.handelGetListPage()
  },
  methods: {
    search() {
      this.filter.page = 1
      this.handelGetListPage()
    },
    reset() {
      this.filter = this.$options.data().filter
      this.search()
    },
    handelGetListPage() {
      this.loading = true
      getAccList(this.filter).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.total = Number(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toView (row) {
      this.opearteType = 'detail'
      this.currentAcc = row.name
      this.accFilter.qwUserId = row.userid
      this.accFilter.flag = 2
      this.handleFilter()
      this.dialogAccVisible = true
    },
    toAdd (row) {
      this.opearteType = 'add'
      this.currentAcc = row.name
      this.accFilter.qwUserId = row.userid
      this.accFilter.flag = 1
      this.handleFilter()
      this.dialogAccVisible = true
    },
    handleFilter() {
      this.accFilter.page = 1
      this.handleGetAccList()
    },
    handleResetFilter() {
      this.accFilter.names = ''
      this.accFilter.insertStartDate = ''
      this.accFilter.insertEndDate = ''
      this.accFilter.page = 1
      this.accFilter.limit = 10
      this.dateList = []
      this.handleGetAccList()
    },
    // 获取活码关联列表
    handleGetAccList() {
      this.accLoading = true
      getQwLiveCodeList(this.accFilter).then(({ code, data }) => {
        if (code === 0) {
          this.accList = data.records
          this.accTotal = Number(data.total)
          this.$nextTick(() => {
            this.echo()
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.accLoading = false
        }, 300)
      })
    },
    handleDelete () {
      this.$confirm('确认删除所选活码关联?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const i = this.accSelection.map(({ id }) => id)
        const params = {
          qwUserId: this.accFilter.qwUserId,
          codeIds: i.join(',')
        }
        this.submitLoading = true
        batchDel(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('删除成功!')
          }
        }).finally(() => {
          setTimeout(() => {
            this.accSelection = []
            this.handleGetAccList()
            this.submitLoading = false
          }, 5000)
        })
      })
    },
    handleDeleteAll () {
      this.$confirm('确认删除所有活码关联?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          qwUserId: this.accFilter.qwUserId
        }
        this.submitLoading = true
        batchDelAll(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('删除成功!')
            this.handleCloseAcc()
          }
        }).finally(() => {
          this.accSelection = []
          this.handleGetAccList()
          this.submitLoading = false
        })
      })
    },
    toDelete (row) {
      this.$confirm('确认删除当前活码关联?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          qwUserId: this.accFilter.qwUserId,
          codeIds: row.id
        }
        this.submitLoading = true
        batchDel(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('删除成功!')
          }
        }).finally(() => {
          setTimeout(() => {
            this.handleDelItem(row)
            this.handleGetAccList()
            this.submitLoading = false
          }, 5000)
        })
      })
    },
    handleAdd () {
      this.$confirm('确认关联所选活码?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const i = this.accSelection.map(({ id }) => id)
        const params = {
          qwUserId: this.accFilter.qwUserId,
          codeIds: i.join(',')
        }
        this.submitLoading = true
        batchAdd(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('关联成功!')
          }
        }).finally(() => {
          setTimeout(() => {
            this.accSelection = []
            this.handleGetAccList()
            this.submitLoading = false
          }, 5000)
        })
      })
    },
    handleAddAll () {
      this.$confirm('确认关联所有活码?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          qwUserId: this.accFilter.qwUserId
        }
        this.submitLoading = true
        batchAddAll(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('关联成功!')
            this.handleCloseAcc()
          }
        }).finally(() => {
          this.accSelection = []
          this.handleGetAccList()
          this.submitLoading = false
        })
      })
    },
    toChoose (row) {
      this.$confirm('确认关联当前活码?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          qwUserId: this.accFilter.qwUserId,
          codeIds: row.id
        }
        this.submitLoading = true
        batchAdd(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('关联成功!')
          }
        }).finally(() => {
          setTimeout(() => {
            this.handleDelItem(row)
            this.handleGetAccList()
            this.submitLoading = false
          }, 5000)
        })
      })
    },
    handleSelect(_, row) {
      // isExited判断selected是否已经存在当前项
      let isExited = false
      this.accSelection.forEach(item => {
        if(item.id === row.id) {
          isExited = true
        }
      })
      if (isExited) {
        // 若存在，代表操作是 取消选中
        this.handleDelItem(row)
      } else {
        // 反之，选中某项
        this.accSelection.push(row)
      }
    },
    handleSelectionAll(selection) {
      if (selection.length === 0) {
        // 若是全不选，则循环删除selected数组中存在的项
        this.accList.forEach(item => {
          this.handleDelItem(item)
        })
      } else {
        // 全选，将selected和当前table数据合起来，注意去重！
        this.accSelection = unique(this.accSelection.concat(this.accList), 'id')
      }
    },
    handleDelSelection ({ id }) {
      const t = this.accList.find(item => item.id === id)
      if (t) {
        this.handleDelItem(t)
        this.$refs.multipleTable.toggleRowSelection(t, false)
      }
    },
    handleDelItem(row){
      let index = -1
      this.accSelection.forEach((item, idx) => {
        if(item.id === row.id) {
          index = idx
        }
      })
      if (index >= 0) {
        this.accSelection.splice(index, 1)
      }
    },
    echo() {
      let rows = []
      this.accList.forEach(row => {
        this.accSelection.forEach(item => {
          if (row.id === item.id) {
            rows.push(row)
          }
        })
      })
      this.toggleSelection(rows)
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleViewNum (row, index) {
      if (row.codeNum) {
        return
      }
      getRelevenceCodeNum({ qwUserId: row.userid }).then(({ code, data }) => {
        if (code === 0) {
          this.list.forEach((item, i) => {
            if (i === index) {
              this.$set(item, 'codeNum', data)
            }
          })
        }
      })
    },
    handleCloseAcc() {
      this.accList = []
      this.accSelection = []
      this.accFilter = this.$options.data().accFilter
      this.dateList = []
      this.accTotal = 0
      this.$refs.multipleTable.clearSelection()
      this.dialogAccVisible = false
    },
    handleSizeChange (val) {
      this.limit = val
      this.handelGetListPage()
    },
    handleCurrentChange (current) {
      this.filter.page = current
      this.handelGetListPage()
    },
    handleSizeChangeAcc(v) {
      this.accFilter.page = 1
      this.accFilter.limit = v
      this.handleGetAccList()
    },
    handleCurrentChangeAcc(v) {
      this.accFilter.page = v
      this.handleGetAccList()
    }
  }
}
</script>

<style lang="scss" scoped>
.operate-line {
  margin-bottom: 10px;
}
.timerange {
  width: 300px;
  ::v-deep .el-range-separator {
    width: 20px;
  }
}
.tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
